import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { FaHome, FaQrcode, FaTrophy, FaGift, FaUser, FaSignOutAlt, FaUsers, FaComments, FaNewspaper, FaBars, FaTimes, FaBoxOpen, FaBell } from 'react-icons/fa';
import { theme } from '../../styles/theme';
import api from '../../services/ApiService';
import UniversalApiClient, { strapiClient } from '../../services/UniversalApiClient';

const MEDIA_BASE_URL = (
  process.env.REACT_APP_BACKEND_URL ||
  process.env.REACT_APP_API_URL ||
  ''
).replace(/\/$/, '');

const resolveAvatarUrl = (url) => {
  if (!url) return null;
  const s = String(url).trim();
  if (!s) return null;
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:') || s.startsWith('blob:')) return s;
  if (!MEDIA_BASE_URL) return s;
  return `${MEDIA_BASE_URL}${s.startsWith('/') ? '' : '/'}${s}`;
};


const NavSpacer = styled.div`
  height: calc(96px + env(safe-area-inset-top, 0px));
  
  @media (max-width: 1024px) {
    height: calc(80px + env(safe-area-inset-top, 0px));
  }
  
  @media (max-width: 768px) {
    height: calc(72px + env(safe-area-inset-top, 0px));
  }
`;

const Nav = styled.nav`
  background: ${theme.colors.cardBackground};
  border-bottom: 1px solid ${theme.colors.cardBorder};
  padding: ${theme.spacing.md} ${theme.spacing.xl};
  padding-top: calc(${theme.spacing.md} + env(safe-area-inset-top, 0px));
  backdrop-filter: blur(10px);
  position: fixed;
  top: ${props => props.$isVisible ? '0' : '-100px'};
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
  box-sizing: border-box;
  transition: top 0.3s ease;
  
  @media (max-width: 1024px) {
    padding: ${theme.spacing.sm} ${theme.spacing.md};
    padding-top: calc(${theme.spacing.sm} + env(safe-area-inset-top, 0px));
  }
  
  @media (max-width: 768px) {
    padding: ${theme.spacing.sm};
    padding-top: calc(${theme.spacing.sm} + env(safe-area-inset-top, 0px));
  }
`;

const NavContainer = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  position: relative;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  flex-shrink: 0;
  cursor: pointer;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
  }
  
  @media (max-width: 768px) {
    gap: ${theme.spacing.sm};
  }
`;

// const LogoIcon = styled.div`
//   width: 40px;
//   height: 40px;
//   background: ${theme.gradients.primary};
//   border-radius: ${theme.borderRadius.medium};
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-weight: ${theme.typography.fontWeights.bold};
//   color: #000;
//   font-size: ${theme.typography.fontSizes.md};
//   box-shadow: ${theme.shadows.logo};

//   &::before {
//     content: 'GG';
//   }
// `;

const LogoIcon = () => (
<img src="images/GGlogo.svg" alt="Logo" style={{ height: '64px',marginLeft:"8px" }} />
);

const Logo = styled.h1`
  color: ${theme.colors.textPrimary};
  margin: 0;
  font-size: clamp(1.2rem, 3vw, ${theme.typography.fontSizes.xl});
  font-weight: ${theme.typography.fontWeights.bold};
  background: ${theme.gradients.primary};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  white-space: nowrap;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  z-index: 1001;
  color: ${theme.colors.textPrimary};
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  transition: color 0.3s ease;
  position: relative;
  
  &:hover {
    color: ${theme.colors.primary};
  }
  
  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  align-items: center;
  flex: 1;
  justify-content: center;
  
  @media (max-width: 1024px) {
    position: fixed;
    top: 0;
    right: ${props => props.$isOpen ? '0' : '-100%'};
    width: 280px;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(20px);
    flex-direction: column;
    padding: ${theme.spacing.xl};
    padding-top: calc(80px + env(safe-area-inset-top, 0px));
    border-left: 1px solid ${theme.colors.cardBorder};
    transition: right 0.3s ease;
    overflow-y: auto;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
    z-index: 999;
  }
`;

const NavLink = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.textSecondary};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  border-radius: ${theme.borderRadius.medium};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  font-size: clamp(0.85rem, 1.5vw, ${theme.typography.fontSizes.md});
  font-weight: ${theme.typography.fontWeights.medium};
  transition: all 0.3s ease;
  border: 1px solid transparent;
  white-space: nowrap;
  
  &:hover {
    color: ${theme.colors.primary};
    background: ${theme.colors.hover};
    border-color: ${theme.colors.cardBorder};
  }
  
  &.active {
    color: #000;
    background: ${theme.gradients.primary};
    border-color: ${theme.colors.primary};
    box-shadow: ${theme.shadows.button};
  }
  
  @media (max-width: 1024px) {
    width: 100%;
    justify-content: flex-start;
    padding: ${theme.spacing.md};
    font-size: 1rem;
  }
`;

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: black;
  border: 1px solid ${theme.colors.cardBorder};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.card};
  backdrop-filter: blur(10px);
  min-width: 180px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  margin-top: ${theme.spacing.sm};
  
  @media (max-width: 1024px) {
    position: static;
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    width: 100%;
    border: none;
    box-shadow: none;
    background: transparent;
    margin-top: 0;
    padding-left: ${theme.spacing.md};
  }
`;

const DropdownItem = styled.button`
  width: 100%;
  background: none;
  border: none;
  color: ${theme.colors.textSecondary};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  font-size: clamp(0.8rem, 1.5vw, ${theme.typography.fontSizes.sm});
  transition: all 0.3s ease;
  
  &:hover {
    color: ${theme.colors.primary};
    background: ${theme.colors.hover};
  }
  
  &:first-child {
    border-top-left-radius: ${theme.borderRadius.medium};
    border-top-right-radius: ${theme.borderRadius.medium};
  }
  
  &:last-child {
    border-bottom-left-radius: ${theme.borderRadius.medium};
    border-bottom-right-radius: ${theme.borderRadius.medium};
  }
  
  @media (max-width: 1024px) {
    padding: ${theme.spacing.sm};
    font-size: 0.9rem;
    border-radius: ${theme.borderRadius.medium} !important;
    margin-bottom: ${theme.spacing.xs};
    
    &:hover {
      background: ${theme.colors.hover};
    }
  }
`;

const NavLinkWithDropdown = styled(NavLink)`
  &:hover + ${DropdownMenu},
  &:focus + ${DropdownMenu} {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`;

const CommunityDropdown = styled(DropdownContainer)`
  &:hover ${DropdownMenu} {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
  
  @media (max-width: 1024px) {
    width: 100%;
    
    &:hover ${DropdownMenu} {
      position: static;
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
      margin-top: ${theme.spacing.sm};
      box-shadow: none;
    }
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  color: ${theme.colors.textPrimary};
  flex-shrink: 0;
  
  @media (max-width: 1024px) {
    gap: ${theme.spacing.sm};
  }
  
  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: ${theme.spacing.sm};
  }
`;

const UserName = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  color: ${theme.colors.textSecondary};
  font-size: clamp(0.8rem, 1.5vw, ${theme.typography.fontSizes.md});
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const PointsBadge = styled.span`
  background: ${theme.gradients.primary};
  color: #000;
  display: flex;
  align-items: center;
  height: 30px;
  margin-top: 0;
  padding-left: ${theme.spacing.md};
  padding-right: ${theme.spacing.md};
  gap: ${theme.spacing.sm};
    
  border-radius: ${theme.borderRadius.large};
  font-weight: ${theme.typography.fontWeights.semibold};
  font-size: clamp(0.75rem, 1.5vw, ${theme.typography.fontSizes.sm});
  white-space: nowrap;
  
  img {
    display: block;
    vertical-align: middle;
  }
  
  @media (max-width: 1024px) {
    justify-content: center;
  }
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    height: 28px;
    padding-left: ${theme.spacing.sm};
    padding-right: ${theme.spacing.sm};
    
    img {
      width: 18px !important;
      height: 18px !important;
    }
  }
`;

const MobileOverlay = styled.div`
  display: none;
  
  @media (max-width: 1024px) {
    display: ${props => props.$isOpen ? 'block' : 'none'};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 998;
  }
`;

const NotificationButton = styled.div`
  position: relative;
  cursor: pointer;
  margin-right: ${theme.spacing.md};
  color: ${theme.colors.textSecondary};
  font-size: 1.2rem;
  transition: color 0.2s;
  display: flex;
  align-items: center;

  &:hover {
    color: ${theme.colors.textPrimary};
  }
  
  @media (max-width: 1024px) {
    display: none;
  }
`;

const NotificationBadge = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: ${theme.colors.error};
  color: white;
  font-size: 0.7rem;
  font-weight: bold;
  height: 16px;
  min-width: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-shadow: 0 0 0 2px ${theme.colors.cardBackground};
`;

const NavAvatarWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  cursor: pointer;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const NavAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${props => props.$hasImage ? 'transparent' : theme.gradients.primary};
  border: 2.5px solid ${props => props.$frameColor || 'rgba(255, 215, 0, 0.3)'};
  box-shadow: 0 0 8px ${props => props.$frameColor ? `${props.$frameColor}44` : 'rgba(255, 215, 0, 0.15)'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: bold;
  color: #000;
  overflow: hidden;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
`;

const NavAvatarImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

const NavBadge = styled.div`
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${theme.gradients.primary};
  border: 1.5px solid ${theme.colors.cardBackground};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 50%;
  }
`;

/* Avatar wrapper used inside MobileMenuButton — replaces the burger icon */
const NavAvatarMobileToggle = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/* Small notification dot on the mobile avatar toggle */
const MobileAvatarNotifBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: ${theme.colors.error};
  color: white;
  font-size: 0.6rem;
  font-weight: bold;
  height: 16px;
  min-width: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  box-shadow: 0 0 0 2px ${theme.colors.cardBackground};
  pointer-events: none;
`;

const MobileNotificationsSection = styled.div`
  display: none;
  
  @media (max-width: 1024px) {
    display: block;
    width: 100%;
    padding: ${theme.spacing.md} 0;
    border-bottom: 1px solid ${theme.colors.cardBorder};
    margin-bottom: ${theme.spacing.md};
  }
`;

const MobileNotificationsTitle = styled.div`
  color: ${theme.colors.textPrimary};
  font-size: ${theme.typography.fontSizes.md};
  font-weight: ${theme.typography.fontWeights.semibold};
  margin-bottom: ${theme.spacing.sm};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  justify-content: space-between;
`;

const ViewAllLink = styled.span`
  color: ${theme.colors.primary};
  font-size: ${theme.typography.fontSizes.sm};
  font-weight: ${theme.typography.fontWeights.medium};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    text-decoration: underline;
    color: ${theme.colors.textPrimary};
  }
`;

const MobileNotificationItem = styled.div`
  background: ${theme.colors.hover};
  border: 1px solid ${theme.colors.cardBorder};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.sm};
  margin-bottom: ${theme.spacing.xs};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${theme.colors.cardBackground};
    border-color: ${theme.colors.primary};
  }
`;

const MobileNotificationTitle = styled.div`
  color: ${theme.colors.textPrimary};
  font-size: ${theme.typography.fontSizes.sm};
  font-weight: ${theme.typography.fontWeights.medium};
  margin-bottom: ${theme.spacing.xs};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MobileNotificationMessage = styled.div`
  color: ${theme.colors.textSecondary};
  font-size: ${theme.typography.fontSizes.xs};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const EmptyNotifications = styled.div`
  color: ${theme.colors.textSecondary};
  font-size: ${theme.typography.fontSizes.sm};
  text-align: center;
  padding: ${theme.spacing.md} 0;
  font-style: italic;
`;

const LockedWalletPill = styled.div`
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.14) 0%, rgba(255, 140, 0, 0.1) 100%);
  border: 1px solid rgba(255, 215, 0, 0.28);
  border-radius: ${theme.borderRadius.large};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
`;

const LockedWalletName = styled.div`
  color: ${theme.colors.textPrimary};
  font-size: clamp(0.92rem, 1.6vw, ${theme.typography.fontSizes.md});
  font-weight: ${theme.typography.fontWeights.semibold};
  text-transform: none;
  letter-spacing: 0.01em;
  white-space: nowrap;
`;

const Navigation = ({ user, currentView, onViewChange, onLogout, requiresScan, lockedMode = false }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);
  const [displayPoints, setDisplayPoints] = useState(Number(user?.points || 0));
  const [latestNotifications, setLatestNotifications] = useState([]);
  const sseRef = useRef(null);
  const sseReconnectTimerRef = useRef(null);
  const sseRetryRef = useRef(0);

  // Read latest user data (avatarUrl, metadata) from localStorage for cosmetics
  const [userAvatarUrl, setUserAvatarUrl] = useState(user?.avatarUrl || null);
  const [userMeta, setUserMeta] = useState(user?.metadata || {});

  useEffect(() => {
    // Sync from user prop
    setUserAvatarUrl(user?.avatarUrl || null);
    setUserMeta(user?.metadata || {});
    // Also read latest from localStorage in case profile page updated it
    try {
      const stored = JSON.parse(localStorage.getItem('user') || '{}');
      if (stored.avatarUrl) setUserAvatarUrl(stored.avatarUrl);
      if (stored.metadata) setUserMeta(stored.metadata);
    } catch {}
  }, [user]);

  // Real-time notification updates via Server-Sent Events
  useEffect(() => {
    if (!user || lockedMode) return;

    let isMounted = true;

    const refreshLatestUnread = async () => {
      try {
        const notificationsRes = await api.getNotifications(1, 20);
        const allNotifications = notificationsRes?.data || [];
        const unreadNotifications = allNotifications.filter(n => !n.isRead).slice(0, 2);
        console.log('📱 Refreshed latest unread notifications:', unreadNotifications);
        if (isMounted) setLatestNotifications(unreadNotifications);
      } catch (e) {
        console.error('❌ Error refreshing notifications:', e);
      }
    };

    // Always fetch an initial count so the badge shows even if SSE fails.
    (async () => {
      try {
        const res = await api.getUnreadNotificationCount();
        const count = res?.count ?? res?.data?.count ?? 0;
        if (isMounted) setUnreadCount(count);
        
        // Fetch last 2 unread notifications for mobile menu
        await refreshLatestUnread();
      } catch (e) {
        console.error('❌ Error fetching notifications:', e);
        // Keep badge at 0 on failure
      }
    })();

    // Cookie-auth SSE via fetch streaming (supports credentials).
    // Derive base URL from the unified Strapi client.
    const apiBase = strapiClient?.defaults?.baseURL || '';
    const strapiBase = apiBase.replace(/\/api$/, '');
    const fallbackToken = UniversalApiClient.getAuthToken();
    const streamUrl = fallbackToken
      ? `${strapiBase}/api/notifications/stream?token=${encodeURIComponent(fallbackToken)}`
      : `${strapiBase}/api/notifications/stream`;

    const connectSSE = () => {
      // Clean up any previous connection/timer
      if (sseReconnectTimerRef.current) {
        clearTimeout(sseReconnectTimerRef.current);
        sseReconnectTimerRef.current = null;
      }

      const abortController = new AbortController();
      sseRef.current = abortController;

      console.log('📡 SSE connecting (cookie auth):', streamUrl);

      (async () => {
        try {
          const response = await fetch(streamUrl, {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Accept': 'text/event-stream',
              ...(fallbackToken ? { Authorization: `Bearer ${fallbackToken}` } : {})
            },
            signal: abortController.signal
          });

          if (!response.ok) {
            throw new Error(`SSE HTTP ${response.status}`);
          }

          sseRetryRef.current = 0;
          const reader = response.body.getReader();
          const decoder = new TextDecoder('utf-8');
          let buffer = '';

          while (isMounted) {
            const { value, done } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, { stream: true });

            // SSE events are separated by a blank line
            const parts = buffer.split('\n\n');
            buffer = parts.pop() || '';

            for (const part of parts) {
              const lines = part.split('\n');
              for (const line of lines) {
                if (!line.startsWith('data:')) continue;
                const payload = line.slice(5).trim();
                if (!payload) continue;
                try {
                  const data = JSON.parse(payload);
                  if (data.type === 'count') {
                    const next = Number.isFinite(data.count) ? data.count : 0;
                    setUnreadCount(next);
                    
                    // Refresh latest unread notifications when count changes
                    await refreshLatestUnread();
                  }
                } catch (e) {
                  // ignore parse errors for non-json events
                }
              }
            }
          }
        } catch (error) {
          if (!isMounted) return;
          console.error('❌ SSE connection error:', error);
        }

        const retry = sseRetryRef.current;
        const delay = Math.min(30000, 1000 * Math.pow(2, retry));
        sseRetryRef.current = retry + 1;

        if (isMounted) {
          sseReconnectTimerRef.current = setTimeout(() => {
            if (isMounted) connectSSE();
          }, delay);
        }
      })();
    };

    connectSSE();

    return () => {
      isMounted = false;
      if (sseReconnectTimerRef.current) {
        clearTimeout(sseReconnectTimerRef.current);
        sseReconnectTimerRef.current = null;
      }
      if (sseRef.current) {
        try {
          sseRef.current.abort?.();
        } catch (e) {
          // ignore
        }
        sseRef.current = null;
      }
    };
  }, [user, lockedMode]);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Keep navbar points in sync with auth context + any global updates
  useEffect(() => {
    setDisplayPoints(Number(user?.points || 0));
  }, [user?.points]);

  useEffect(() => {
    const onPoints = (e) => {
      const next = Number(e?.detail?.points);
      if (Number.isFinite(next)) setDisplayPoints(next);
    };

    const onStorage = (e) => {
      if (e.key !== 'user') return;
      try {
        const parsed = e.newValue ? JSON.parse(e.newValue) : null;
        const next = Number(parsed?.points);
        if (Number.isFinite(next)) setDisplayPoints(next);
      } catch (err) {
        // ignore
      }
    };

    window.addEventListener('gg:points', onPoints);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('gg:points', onPoints);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  useEffect(() => {
    console.log('📊 Navigation: Display points:', displayPoints);
  }, [displayPoints]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY < lastScrollY || currentScrollY < 10) {
        // Scrolling up or at top
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down and past threshold
        setIsVisible(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const handleViewChange = (view) => {
    // Block navigation if scan is required and user tries to leave scanner
    if (requiresScan && view !== 'scanner') {
      alert('You must scan at least one QR code to unlock app access. Please use the scanner first.');
      return;
    }
    
    onViewChange(view);
    setIsMobileMenuOpen(false);
  };

  const handleLogout = () => {
    onLogout();
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      {!lockedMode && <MobileOverlay $isOpen={isMobileMenuOpen} onClick={() => setIsMobileMenuOpen(false)} />}
      <NavSpacer />
      <Nav $isVisible={isVisible}>
        <NavContainer>
          <LogoContainer onClick={() => handleViewChange(lockedMode ? 'scanner' : 'dashboard')}>
            <LogoIcon />
            <Logo>TROPHY</Logo>
          </LogoContainer>
          {!lockedMode && (
          <NavLinks $isOpen={isMobileMenuOpen}>
            <MobileNotificationsSection>
              <MobileNotificationsTitle>
                <div style={{ display: 'flex', alignItems: 'center', gap: `${theme.spacing.sm}` }}>
                  <FaBell /> Notifications
                  {unreadCount > 0 && <NotificationBadge>{unreadCount > 99 ? '99+' : unreadCount}</NotificationBadge>}
                </div>
                <ViewAllLink onClick={() => handleViewChange('notifications')}>View All</ViewAllLink>
              </MobileNotificationsTitle>
              {latestNotifications.length > 0 ? (
                <>
                  {latestNotifications.map((notification, index) => (
                    <MobileNotificationItem 
                      key={notification.id || index}
                      onClick={() => handleViewChange('notifications')}
                    >
                      <MobileNotificationTitle>{notification.title || 'Notification'}</MobileNotificationTitle>
                      <MobileNotificationMessage>{notification.message || ''}</MobileNotificationMessage>
                    </MobileNotificationItem>
                  ))}
                </>
              ) : (
                <EmptyNotifications>No new notifications</EmptyNotifications>
              )}
            </MobileNotificationsSection>
            <NavLink
              className={currentView === 'dashboard' ? 'active' : ''}
              onClick={() => handleViewChange('dashboard')}
            >
              <FaHome /> Home
            </NavLink>
            <NavLink
              className={currentView === 'scanner' ? 'active' : ''}
              onClick={() => handleViewChange('scanner')}
            >
              <FaQrcode /> Scan
            </NavLink>
            <NavLink
              className={currentView === 'points' ? 'active' : ''}
              onClick={() => handleViewChange('points')}
            >
              <FaTrophy /> GG Coins
            </NavLink>
            {/* <NavLink
              className={currentView === 'redemption' ? 'active' : ''}
              onClick={() => handleViewChange('redemption')}
            >
              <FaGift /> Redeem
            </NavLink> */}
            <NavLink
              className={currentView === 'catalog' ? 'active' : ''}
              onClick={() => handleViewChange('catalog')}
            >
              <FaGift /> Loot Store
            </NavLink>
            <NavLink
              className={currentView === 'inventory' ? 'active' : ''}
              onClick={() => handleViewChange('inventory')}
            >
              <FaBoxOpen /> Inventory
            </NavLink>
            <CommunityDropdown>
              <NavLinkWithDropdown
                className={currentView === 'community' || currentView === 'chat' || currentView === 'friends' || currentView === 'events' || currentView === 'news' || currentView === 'leaderboard' ? 'active' : ''}
                onClick={() => handleViewChange('community')}
              >
                <FaUsers /> Nexus Hub
              </NavLinkWithDropdown>
              <DropdownMenu>
                <DropdownItem onClick={() => handleViewChange('chat')}>
                  <FaComments /> Chat
                </DropdownItem>
                {/* <DropdownItem onClick={() => handleViewChange('friends')}>
                  <FaUserFriends /> Friends
                </DropdownItem> */}
                {/* <DropdownItem onClick={() => handleViewChange('events')}>
                  <FaCalendarAlt /> Events
                </DropdownItem> */}
                {/* <DropdownItem onClick={() => handleViewChange('leaderboard')}>
                  <FaLeaderboard /> Leaderboard
                </DropdownItem> */}
                <DropdownItem onClick={() => handleViewChange('news')}>
                  <FaNewspaper /> News
                </DropdownItem>
              </DropdownMenu>
            </CommunityDropdown>
            <NavLink
              className={currentView === 'profile' ? 'active' : ''}
              onClick={() => handleViewChange('profile')}
            >
              <FaUser style={{fontSize: '13px'}} /> {user?.username}
            </NavLink>
            <NavLink onClick={handleLogout}>
              <FaSignOutAlt /> Logout
            </NavLink>
          </NavLinks>
          )}
          <UserInfo>
            {!lockedMode && (
            <NotificationButton onClick={() => handleViewChange('notifications')}>
              <FaBell />
              {unreadCount > 0 && <NotificationBadge>{unreadCount > 99 ? '99+' : unreadCount}</NotificationBadge>}
            </NotificationButton>
            )}
            <NavAvatarWrapper onClick={() => handleViewChange('profile')}>
              <NavAvatar
                $hasImage={!!userAvatarUrl}
                $frameColor={userMeta.frameColor}
              >
                {userAvatarUrl
                  ? <NavAvatarImg
                      src={resolveAvatarUrl(userAvatarUrl)}
                      alt={user?.username}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.textContent = user?.username?.substring(0, 2).toUpperCase() || '??';
                      }}
                    />
                  : (user?.username?.substring(0, 2).toUpperCase() || '??')
                }
              </NavAvatar>
              {userMeta.badgeImageUrl && (
                <NavBadge>
                  <img
                    src={resolveAvatarUrl(userMeta.badgeImageUrl)}
                    alt={userMeta.badgeName || 'Badge'}
                    onError={(e) => { e.target.parentElement.style.display = 'none'; }}
                  />
                </NavBadge>
              )}
            </NavAvatarWrapper>
            <UserName>
              {user?.username}
            </UserName>
            <PointsBadge>
              {Number(displayPoints || 0).toLocaleString()} <img src='images/ggcoin.svg' alt='GG Logo' style={{width:"24px", height:"24px"}}/>
            </PointsBadge>
            {!lockedMode && (
              <MobileMenuButton onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                {isMobileMenuOpen ? (
                  <FaTimes />
                ) : (
                  <NavAvatarMobileToggle>
                    <NavAvatar
                      $hasImage={!!userAvatarUrl}
                      $frameColor={userMeta.frameColor}
                    >
                      {userAvatarUrl
                        ? <NavAvatarImg
                            src={resolveAvatarUrl(userAvatarUrl)}
                            alt={user?.username}
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.parentElement.textContent = user?.username?.substring(0, 2).toUpperCase() || '??';
                            }}
                          />
                        : (user?.username?.substring(0, 2).toUpperCase() || '??')
                      }
                    </NavAvatar>
                    {userMeta.badgeImageUrl && (
                      <NavBadge>
                        <img
                          src={resolveAvatarUrl(userMeta.badgeImageUrl)}
                          alt={userMeta.badgeName || 'Badge'}
                          onError={(e) => { e.target.parentElement.style.display = 'none'; }}
                        />
                      </NavBadge>
                    )}
                    {unreadCount > 0 && <MobileAvatarNotifBadge>{unreadCount > 99 ? '99+' : unreadCount}</MobileAvatarNotifBadge>}
                  </NavAvatarMobileToggle>
                )}
              </MobileMenuButton>
            )}
          </UserInfo>
        </NavContainer>
      </Nav>
    </>
  );
};

export default Navigation;